
import { Calendar } from "@/models/calendar";
import { CalendarEvent } from "@/models/calendar-event";
import { CalendarService } from "@/services/calendar-service";
import Vue from "vue";
import { createConfirmBuilder } from "../../setup/confirm-builder";
import AppCalendarEventEdit from "./CalendarEventEdit.vue";
import AppWrapper from "./CalendarEventEditWrapper.vue";

export default Vue.extend({
	props: {
		event: {
			type: Object as () => CalendarEvent,
			required: true
		},
		maxWidth: {
			type: [String, Number]
		}
	},
	computed: {
		calendars():Calendar[] {
			return CalendarService.cachedCalendars;
		},
		title():string {
			return this.$ct(this.event.ID == 0 ? "new-event" : "edit-event").toString();
		},
		calendarName():string {
			let calendar = this.calendars.find(c => c.ID == this.event.CalendarID);
			if (calendar) return calendar.Name;
			if (this.event.Calendar) return this.event.Calendar.Name;
			return "";
		}
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		async save() {
			if (this.event.ID == 0) {
				await CalendarService.postEvents([this.event]);
			} else {
				await CalendarService.putEvents([this.event]);
			}
			this.$emit("save");
			this.$emit("close");
		},
		async deleteEvent() {
			let confirmed = await createConfirmBuilder.bind(this)(this.$ct("confirm-event-delete")).setWarningTitle().show();
			if (!confirmed) {
				return;
			}
			await CalendarService.deleteEvents([this.event]);
			this.$emit("delete");
			this.$emit("close");
		}
	},
	async mounted() {
		await CalendarService.getCalendars();
	},
	components: {
		AppCalendarEventEdit,
		AppWrapper
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
